import Qs from 'qs';
import { addTimestamp, rdc } from '@saucelabs/sl-util-axios';

const fetchFilteredDevices = (payload) => rdc.get('/devices/filtered', {
  params: payload,
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
});

const fetchAllAvailableDeviceIds = () => rdc.get('/devices/available', addTimestamp())
  .then(({ data }) => data);

const fetchSessionAvailable = () => (
  rdc.get('/concurrency/manual', addTimestamp())
);

export default {
  fetchAllAvailableDeviceIds,
  fetchFilteredDevices,
  fetchSessionAvailable,
};
